/**
 *
 * FreshPets Opacities
 *
 */
const opacities = [0.15, 0.3, 0.45, 0.6, 0.75, 1]

export default opacities